// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"e5eb31b4","929":"20a8b495","971":"f6ea6745","999":"b8564f33"}[chunkId] + ".chunk.css";
};